module.exports = __webpack_public_path__ + "img/img_client_macOS.a82eee6a.jpg";